import { Delete, Get, Post } from './helpers';
import { Template } from '@/types/template.types';
import { IUserTemplateFavorite } from '@/types/profile.types';

export const GetTemplates = (channel: number): Promise<Template[]> => {
  return Get({ path: `/v3/admin/events/templates/${channel}` });
};

export function GetUserTemplateFavorites({ channel }: { channel: number }): Promise<IUserTemplateFavorite[]> {
  return Get({
    path: `/v3/admin/events/user-template-favorites/${channel}`,
  });
}

export type TUpdateTemplateFavoriteParams = {
  activeChannel: number;
  adminId: number;
  projectUuid: string;
};

export const DeleteUserTemplateFavorite = ({
  activeChannel,
  adminId,
  projectUuid,
}: TUpdateTemplateFavoriteParams): Promise<void> => {
  return Delete({
    path: `/v3/admin/events/user-template-favorites/${activeChannel}/${projectUuid}/${adminId}`,
  });
};

export const AddUserTemplateFavorite = ({
  activeChannel,
  adminId,
  projectUuid,
}: TUpdateTemplateFavoriteParams): Promise<IUserTemplateFavorite> => {
  return Post({
    path: `/v3/admin/events/user-template-favorites/${activeChannel}/${projectUuid}/${adminId}`,
  });
};

export const DeleteCustomTemplates = (channel: number, templates: string[]) => {
  return Post({ url: `/v3/admin/delete/custom-event-template/${channel}`, body: { templates } });
};
